import React from "react";
import { Button } from "@/components/ui/button";
import { Undo, Redo } from "lucide-react";

interface HistoryGroupProps {
  disabled: boolean;
  onToggleFormat: (format: string) => void;
}

export function HistoryGroup({ disabled, onToggleFormat }: HistoryGroupProps) {
  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => onToggleFormat("undo")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Undo"
      >
        <Undo className="h-4 w-4" />
      </Button>

      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => onToggleFormat("redo")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Redo"
      >
        <Redo className="h-4 w-4" />
      </Button>
    </>
  );
}
